import template from './jobAdd.template.html';

export default {
  template,
  bindings: {
    jobTypes: '<',
    accounts: '<',
    showAccounts: '<',
    workflow: '<',
    ticket: '<',
    contact: '<',
    labels: '<',
    onCancelled: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $state,
      $timeout,
      $mdMedia,
      jobService,
      ticketService,
      ticketsService,
      workflowsService,
      dateTimeService,
      uiService,
      Job,
      JobItem,
      JobProgress,
      TimeUnit,
      Ticket,
      Workflow,
      TICKET
    ) {
      'ngInject';

      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentCurrency = null;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();

        ctrl.job = Job.blank();

        ctrl.availableRepeats = Job.availableRepeats();
        ctrl.availableDaysOfTheWeek = Job.availableDaysOfTheWeek();
        ctrl.availableEndOptions = Job.availableEndOptions();
        ctrl.availableRepeatEvery = Job.availableRepeatEvery();

        const date = dateTimeService.setDate(
          moment.utc().tz(ctrl.currentTimeZone).startOf('day'),
          ctrl.currentTimeZone
        );
        ctrl.job.absoluteDueDate = parseInt(moment.utc(date).format('X') || 0, 10);
        dateTimeService.getSet(ctrl, ctrl.job, 'absoluteDueDate', 'getSetAbsoluteDate');
        dateTimeService.getSet(
          ctrl,
          ctrl.job,
          'repeat.duration.startDate',
          'getSetRepeatStartDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.job,
          'repeat.duration.endDate',
          'getSetRepeatEndDate'
        );
        ctrl.changeAbsoluteDueDate();

        ctrl.showAccounts = ctrl.showAccounts || false;
        ctrl.jobTypes = ctrl.jobTypes || [];
        ctrl.accountsFiltered = ctrl.accounts || [];
        ctrl.workflowsFiltered = ctrl.workflow ? [ctrl.workflow] : [];
        ctrl.ticketsFiltered = ctrl.ticket ? [ctrl.ticket] : [];
        ctrl.contactsFiltered = ctrl.contact ? [ctrl.contact] : [];
        ctrl.showAdditionalOptions = false;
        if (ctrl.ticketsFiltered.length && ctrl.workflowsFiltered.length) {
          ctrl.showAdditionalOptions =
            (ctrl.ticketsFiltered.length === 1 && ctrl.workflowsFiltered.length === 1) ||
            ctrl.job.idTicket !== '';
        } else if (ctrl.contactsFiltered.length) {
          ctrl.showAdditionalOptions =
            ctrl.contactsFiltered.length === 1 || ctrl.job.idContact !== '';
        }
        ctrl.showTicket = ctrl.showTicket || false;
        ctrl.isTasksPage = ctrl.isTasksPage ? ctrl.isTasksPage : false;
        ctrl.showRepeatOptions = ctrl.job.isRecurring;
        ctrl.completedInitialization = true;
        ctrl.isWorkflowReady = false;
        ctrl.isTicketReady = false;
        ctrl.ticketName = '';
        ctrl.repeatEvery = '';
        ctrl.timeIntervalAvailable = TimeUnit.Available;
        ctrl.stageJobTemplate = angular.copy(ctrl.job);
        ctrl.startSaveProcess = false;

        if (ctrl.isTasksPage) {
          ctrl.getWorkflowsAvailable();
        }

        const aIdx = _.findIndex(ctrl.accounts, (a) => a.id === $rootScope.CurrentAccount.id);
        if (ctrl.showAdditionalOptions) {
          if (ctrl.contactsFiltered.length === 1) {
            ctrl.job.idContact = ctrl.contact.id;
            ctrl.job.idAssignedTo =
              aIdx > -1 ? $rootScope.CurrentAccount.id : ctrl.accounts[0].id;
          } else if (ctrl.ticketsFiltered.length === 1 && ctrl.workflowsFiltered.length === 1) {
            ctrl.job.idAssignedTo =
              aIdx > -1 ? $rootScope.CurrentAccount.id : ctrl.accounts[0].id;
            ctrl.job.idWorkflow = ctrl.workflowsFiltered[0].id;
            ctrl.isWorkflowReady = true;
            ctrl.job.idTicket = ctrl.ticketsFiltered[0].id;
            ctrl.isTicketReady = true;
          } else if (ctrl.getTicket(ctrl.job.idTicket) === undefined) {
            ctrl.getCurrentTicket(ctrl.job.idTicket);
          } else {
            ctrl.getTicketsAvailable(ctrl.job.idWorkflow);
          }
        } else {
          ctrl.accountsFiltered = ctrl.accounts;
          ctrl.job.idAssignedTo =
            aIdx > -1 ? $rootScope.CurrentAccount.id : ctrl.accountsFiltered[0].id;
        }
      };

      ctrl.getWorkflowsAvailable = () => {
        ctrl.isWorkflowReady = false;
        workflowsService.getAvailable({ isActive: true }).then((workflows) => {
          ctrl.workflowsFiltered = workflows.filter(
            (w) => w.idTeamMembers.indexOf(ctrl.job.idAssignedTo) >= 0
          );
          ctrl.selectWorkflow(ctrl.workflowsFiltered, ctrl.job.idWorkflow);
          ctrl.isWorkflowReady = true;

          if (ctrl.workflowsFiltered.length === 1) {
            ctrl.job.idWorkflow = ctrl.workflowsFiltered[0].id;
            ctrl.getTicketsAvailable(ctrl.workflowsFiltered[0].id);
          }

          ctrl.setAccounts(ctrl.selectedWorkflow, ctrl.accounts);
        });
      };

      ctrl.getTicketsAvailable = (idWorkflow) => {
        ctrl.isTicketReady = false;
        ticketsService
          .getByWorkflow({ idWorkflow, fields: TICKET.FIELDS.BOARD, idFilter: null })
          .then((tickets) => {
            ctrl.ticketsFiltered = tickets;
            ctrl.selectTicket(ctrl.ticketsFiltered, ctrl.job.idTicket);
            ctrl.isTicketReady = true;

            if (ctrl.ticketsFiltered.length === 1) {
              ctrl.job.idTicket = ctrl.ticketsFiltered[0].id;
              ctrl.ticketName = ctrl.ticketsFiltered[0].getName();
              if (!_.isUuid(ctrl.job.idAssignedTo)) {
                if (ctrl.selectedTicket && ctrl.selectedTicket.idOwner) {
                  ctrl.job.idAssignedTo = ctrl.selectedTicket.idOwner;
                }
              }
            }
          });
      };

      // Get Current Ticket
      ctrl.getTicket = (idTicket) => ctrl.ticketsFiltered.find((t) => t.id === idTicket);

      ctrl.getCurrentTicket = (idTicket) =>
        ticketService.readTicket({ id: idTicket }).then((ticket) => {
          ctrl.ticketsFiltered = [ticket];
          ctrl.selectTicket(ctrl.ticketsFiltered, ctrl.job.idTicket);
          ctrl.isTicketReady = true;
        });

      // Add/Remove Labels
      ctrl.jobLabelsSelected = (selectedLabels = []) => {
        ctrl.job.idLabels = _.uniq([...ctrl.job.idLabels, ...selectedLabels]);
      };

      // Toggle complete job
      ctrl.toggleCompleteJob = () => {
        ctrl.job.isCompleted = !ctrl.job.isCompleted;
      };

      // Toggle workflow and ticket options
      ctrl.toggleAdditionalOptions = () => {
        ctrl.showAdditionalOptions = !ctrl.showAdditionalOptions;
        if (ctrl.showAdditionalOptions) {
          ctrl.isTicketReady = true;
          ctrl.getWorkflowsAvailable();
        } else {
          ctrl.setAccounts(undefined, ctrl.accounts);
          ctrl.job.idWorkflow = '';
          ctrl.workflowsFiltered = [];
          ctrl.job.idTicket = '';
          ctrl.ticketsFiltered = [];
        }
      };

      // Account actions
      ctrl.changeAssignedTo = () => {
        ctrl.setAccounts(ctrl.selectedWorkflow, ctrl.accounts);
      };

      ctrl.setAccounts = (selectedWorkflow, accounts) => {
        if (selectedWorkflow !== undefined) {
          ctrl.accountsFiltered = _.filter(
            accounts,
            (account) => selectedWorkflow.idTeamMembers.indexOf(account.id) >= 0
          );
          ctrl.getWorkflowsAvailable();
        } else {
          ctrl.accountsFiltered = accounts;
        }
      };

      ctrl.isAssignedToSelected = (a) =>
        a && a.id && ctrl.job.idAssignedTo && ctrl.job.idAssignedTo === a.id;

      // Workflow actions
      ctrl.changeWorkflow = () => {
        ctrl.selectWorkflow(ctrl.workflowsFiltered, ctrl.job.idWorkflow);
        ctrl.setAccounts(ctrl.selectedWorkflow, ctrl.accounts);
        ctrl.getTicketsAvailable(ctrl.selectedWorkflow.id);
      };

      ctrl.selectWorkflow = (workflows, jobIdWorkflow) => {
        ctrl.selectedWorkflow = _.find(workflows, (workflow) => workflow.id === jobIdWorkflow);
        if (ctrl.selectedWorkflow === undefined) {
          ctrl.job.idTicket = '';
          ctrl.ticketsFiltered = [];
        }
      };

      ctrl.isWorkflowSelected = (w) =>
        w && w.id && ctrl.job.idWorkflow && ctrl.job.idWorkflow === w.id;

      // Ticket actions
      ctrl.changeTicket = () => {
        ctrl.selectTicket(ctrl.ticketsFiltered, ctrl.job.idTicket);
        if (ctrl.selectedTicket && ctrl.selectedTicket.idOwner) {
          ctrl.job.idAssignedTo = ctrl.selectedTicket.idOwner;
          ctrl.changeAssignedTo();
        }
      };

      ctrl.selectTicket = (tickets, jobIdTicket) => {
        ctrl.selectedTicket = _.find(tickets, (ticket) => ticket.id === jobIdTicket);
      };

      ctrl.isTicketSelected = (t) =>
        t && t.id && ctrl.job.idTicket && ctrl.job.idTicket === t.id;

      ctrl.ticketView = (idWorkflow, idTicket) => {
        ctrl.cancel();
        $timeout(() => {
          $state.transitionTo('deal', { id: idWorkflow, dd: idTicket });
        });
      };

      ctrl.completedAllSubItems = () => {
        if (ctrl.job.items && ctrl.job.items.length) {
          for (let s = 0; s < ctrl.job.items.length; s += 1) {
            ctrl.job.items[s].isActive = true;
          }
        }
      };

      ctrl.jobPinned = () => {
        ctrl.job.isPinned = !ctrl.job.isPinned;
      };

      // Change Absolute Due Date
      ctrl.changeAbsoluteDueDate = () => {
        const cD = moment.utc().startOf('day');
        const tD = moment.utc().startOf('day').add(1, 'day');
        const aD = moment.utc(ctrl.job.absoluteDueDate, 'X').startOf('day');
        ctrl.job.isOverdue = !ctrl.job.isOverdue && aD.isBefore(cD, 'day');
        ctrl.job.isDue = !ctrl.job.isOverdue && !ctrl.job.isDue && aD.isSame(cD, 'day');
        ctrl.job.isDueAhead = !ctrl.job.isDue && !ctrl.job.isDueAhead && aD.isSame(tD, 'day');
      };

      // Repeat options
      ctrl.toggleRepeatOptions = () => {
        ctrl.showRepeatOptions = !ctrl.showRepeatOptions;
        ctrl.job.isRecurring = !ctrl.job.isRecurring;
        if (ctrl.showRepeatOptions) {
          ctrl.job.repeat.duration.startDate = parseInt(
            moment.utc().tz(ctrl.currentTimeZone).startOf('day').format('X'),
            10
          );
          ctrl.getSetRepeatStartDate(
            moment.utc(ctrl.job.repeat.duration.startDate, 'X').toDate()
          );
          ctrl.job.absoluteDueDate = ctrl.job.repeat.duration.startDate;
          ctrl.changeAbsoluteDueDate();
          ctrl.setDayOfWeek();
          ctrl.getSummary();
        } else {
          ctrl.job.absoluteDueDate = parseInt(
            moment.utc().tz(ctrl.currentTimeZone).startOf('day').add(7, 'days').format('X'),
            10
          );
          ctrl.changeAbsoluteDueDate();
          ctrl.job.repeat = {
            repeats: 2,
            repeatEvery: 1,
            repeatOn: [],
            repeatBy: false,
            duration: { startDate: 0, endOption: 1, occurrence: 0, endDate: 0 }
          };
        }
      };

      ctrl.changeRepeats = () => {
        ctrl.job.repeat.repeatEvery = 1;
        ctrl.changeRepeatEvery();
        ctrl.setDayOfWeek();
      };

      ctrl.changeRepeatEvery = () => {
        const sD = moment.utc(ctrl.job.repeat.duration.startDate, 'X');
        const eD =
          parseInt(ctrl.job.repeat.duration.endDate || 0, 10) !== 0
            ? parseInt(moment.utc(ctrl.job.repeat.duration.endDate, 'X'), 10)
            : 0;
        const rE = ctrl.job.repeat.repeatEvery;
        let nD = '';

        switch (ctrl.job.repeat.repeats) {
          case 1:
            ctrl.job.repeat.repeatOn = [];
            ctrl.job.repeat.repeatBy = false;
            nD = moment.utc(sD).add(rE, 'days');
            break;
          case 2:
            if (ctrl.completedInitialization) {
              ctrl.job.repeat.repeatBy = false;
              ctrl.job.repeat.repeatOn = ctrl.job.repeat.repeatOn.length
                ? ctrl.job.repeat.repeatOn
                : [].concat(sD.isoWeekday());
              if (ctrl.job.repeat.repeatOn.indexOf(sD.isoWeekday()) > -1) {
                nD = sD;
              } else {
                const absoluteDueDate = (day) => {
                  if (day > 7) {
                    return sD.add(rE * 7, 'days');
                  }
                  if (ctrl.job.repeat.repeatOn.indexOf(day) > -1) {
                    return sD.add(day - sD.isoWeekday() - 1, 'days');
                  }
                  return absoluteDueDate(day + 1);
                };
                nD = absoluteDueDate(sD.isoWeekday() + 1);
              }
            } else {
              nD = moment.utc(ctrl.job.absoluteDueDate, 'X');
              ctrl.setAbsoluteDate(nD, eD);
              ctrl.completedInitialization = true;
            }
            break;
          case 3:
            ctrl.job.repeat.repeatOn = [];
            if (!ctrl.job.repeat.repeatBy) {
              const absoluteDueDate = (addMonth) => {
                const aM = addMonth + rE;
                const date = moment.utc(sD).add(aM, 'months');
                if (moment.utc(date).date() === sD.date()) {
                  return date;
                }
                return absoluteDueDate(aM);
              };
              nD = absoluteDueDate(0);
            } else {
              const nMD = moment.utc(sD).add(rE, 'months');
              const sW = sD.week() - moment.utc(sD).startOf('month').week() + 1;
              let s = null;
              if (sW === 1) {
                s = 1;
              } else {
                s = sW > 1 && sW < 5 ? sW : sW - 1;
              }
              nD = ctrl.nthWeekdayOfMonth(sD.isoWeekday(), s, nMD.toDate());
            }
            break;
          case 4:
            ctrl.job.repeat.repeatOn = [];
            ctrl.job.repeat.repeatBy = false;
            nD = moment.utc(sD).add(rE, 'years');
            break;
          default:
            break;
        }
        ctrl.setAbsoluteDate(nD, eD);
      };

      ctrl.setAbsoluteDate = (nextDate, endDate) => {
        if (endDate !== 0) {
          ctrl.job.absoluteDueDate = moment.utc(nextDate).isSameOrAfter(endDate)
            ? endDate
            : parseInt(moment.utc(nextDate).format('X') || 0, 10);
        } else {
          ctrl.job.absoluteDueDate = parseInt(moment.utc(nextDate).format('X') || 0, 10);
        }
        dateTimeService.getSet(ctrl, ctrl.job, 'absoluteDueDate', 'getSetAbsoluteDate');
        ctrl.changeAbsoluteDueDate();
      };

      ctrl.nthWeekdayOfMonth = (weekday, n, wDate) => {
        const date = new Date(wDate.getFullYear(), wDate.getMonth(), 1);
        const add = ((weekday - date.getDay() + 7) % 7) + (n - 1) * 7;
        date.setDate(1 + add);
        return date;
      };

      ctrl.setDayOfWeek = () => {
        const date = moment.utc();
        const dow = date.isoWeekday();
        ctrl.job.repeat.repeatOn.push(dow);
      };

      ctrl.changeEndOptions = () => {
        switch (ctrl.job.repeat.duration.endOption) {
          case 1:
            ctrl.job.repeat.duration.occurrence = 0;
            ctrl.job.repeat.duration.endDate = 0;
            break;
          case 2:
            ctrl.job.repeat.duration.endDate = 0;
            ctrl.job.repeat.duration.occurrence = 5;
            break;
          case 3:
            ctrl.job.repeat.duration.endDate = parseInt(
              moment
                .utc(moment.utc(ctrl.job.repeat.duration.startDate, 'X'))
                .add(1, 'years')
                .format('X') || 0,
              10
            );
            ctrl.getSetRepeatEndDate(
              moment.utc(ctrl.job.repeat.duration.endDate, 'X').toDate()
            );
            ctrl.job.repeat.duration.occurrence = 0;
            break;
          default:
            break;
        }
        ctrl.changeRepeatEvery();
      };

      ctrl.changeEndDate = () => {
        if (
          moment(moment.utc(ctrl.job.repeat.duration.endDate, 'X')).isBefore(
            moment.utc(ctrl.job.repeat.duration.startDate, 'X')
          )
        ) {
          const startDate = moment.utc(ctrl.job.repeat.duration.startDate, 'X');
          ctrl.job.repeat.duration.endDate = parseInt(
            moment.utc(startDate).add(1, 'years').format('X') || 0,
            10
          );
          ctrl.getSetRepeatEndDate(moment.utc(ctrl.job.repeat.duration.endDate, 'X').toDate());
        }
        ctrl.getSummary();
        ctrl.changeRepeatEvery();
      };

      ctrl.getSummary = () => {
        let summary = '';
        let endSummary = '';
        switch (ctrl.job.repeat.repeats) {
          case 1:
            ctrl.repeatEvery = ctrl.job.repeat.repeatEvery === 1 ? 'Day' : 'Days';
            if (ctrl.getOccurrence() === 1) {
              summary = 'Once';
            } else {
              summary =
                ctrl.job.repeat.repeatEvery === 1
                  ? 'Daily'
                  : `Every ${ctrl.job.repeat.repeatEvery} days`;
            }
            break;
          case 2:
            ctrl.repeatEvery = ctrl.job.repeat.repeatEvery === 1 ? 'Week' : 'Weeks';
            if (ctrl.getOccurrence() === 1) {
              summary = 'Once';
            } else {
              summary =
                ctrl.job.repeat.repeatEvery === 1
                  ? `Weekly on ${ctrl.getSelectedDaysOfWeek()}`
                  : `Every ${
                      ctrl.job.repeat.repeatEvery
                    } weeks on ${ctrl.getSelectedDaysOfWeek()}`;
            }
            break;
          case 3:
            ctrl.repeatEvery = ctrl.job.repeat.repeatEvery === 1 ? 'Month' : 'Months';
            if (ctrl.getOccurrence() === 1) {
              summary = 'Once';
            } else {
              summary =
                ctrl.job.repeat.repeatEvery === 1
                  ? `Monthly on ${ctrl.getSelectedRepeatBy()}`
                  : `Every ${
                      ctrl.job.repeat.repeatEvery
                    } months on ${ctrl.getSelectedRepeatBy()}`;
            }
            break;
          case 4:
            ctrl.repeatEvery = ctrl.job.repeat.repeatEvery === 1 ? 'Year' : 'Years';
            if (ctrl.getOccurrence() === 1) {
              summary = 'Once';
            } else {
              summary =
                ctrl.job.repeat.repeatEvery === 1
                  ? `Annually on ${moment
                      .utc(ctrl.job.repeat.duration.startDate, 'X')
                      .format('MMMM D')}`
                  : `Every ${ctrl.job.repeat.repeatEvery} years on ${moment
                      .utc(ctrl.job.repeat.duration.endDate, 'X')
                      .format('LL')}`;
            }
            break;
          default:
            break;
        }
        if (ctrl.job.repeat.duration.endOption === 2) {
          endSummary = ctrl.getOccurrence() === 1 ? '' : `, ${ctrl.getOccurrence()} times`;
        } else {
          endSummary =
            ctrl.job.repeat.duration.endOption === 3
              ? `, until ${moment.utc(ctrl.job.repeat.duration.endDate, 'X').format('LL')}`
              : '';
        }
        return summary + endSummary;
      };

      ctrl.getOccurrence = () => {
        if (ctrl.job.repeat.duration.occurrence <= 0) {
          ctrl.job.repeat.duration.occurrence =
            ctrl.job.repeat.duration.endOption === 2 ? 1 : 0;
        }
        return ctrl.job.repeat.duration.occurrence;
      };

      ctrl.getSelectedDaysOfWeek = () => {
        let output = '';
        const days = [];
        const selDays = ctrl.job.repeat.repeatOn.filter((day) =>
          days.push(ctrl.getDayName(day))
        );
        if (selDays.length) {
          if (_.differenceWith(ctrl.job.repeat.repeatOn, [1, 2, 3, 4, 5], _.isEqual)) {
            output = 'weekdays';
          } else if (
            _.differenceWith(ctrl.job.repeat.repeatOn, [1, 2, 3, 4, 5, 6, 7], _.isEqual)
          ) {
            output = 'all days';
          } else {
            output = days.join(',').replace(/,/g, ', ');
          }
        }
        return output;
      };

      ctrl.getDayName = (id) => ctrl.availableDaysOfTheWeek.find((day) => day.id === id).value;

      ctrl.getSelectedRepeatBy = () => {
        const dayOfTheMonth = moment.utc(ctrl.job.repeat.duration.startDate, 'X').date();
        const dayOfTheWeek = moment.utc(ctrl.job.repeat.duration.startDate, 'X').isoWeekday();
        return ctrl.job.repeat.repeatBy
          ? ctrl.weekOfMonth(moment.utc(ctrl.job.repeat.duration.startDate, 'X'), dayOfTheWeek)
          : `day ${dayOfTheMonth}`;
      };

      ctrl.weekOfMonth = (date, dayOfTheWeek) => {
        let output = '';
        const numberOfWeek =
          moment
            .duration(moment.utc(date).endOf('month') - moment.utc(date).startOf('month'))
            .weeks() + 1;
        switch (date.week() - moment.utc(date).startOf('month').week() + 1) {
          case 1:
            output = `the first ${ctrl.getDayName(dayOfTheWeek)}`;
            break;
          case 2:
            output = `the second ${ctrl.getDayName(dayOfTheWeek)}`;
            break;
          case 3:
            output = `the third ${ctrl.getDayName(dayOfTheWeek)}`;
            break;
          case 4:
            output =
              (numberOfWeek === 4 ? 'the last ' : 'the fourth ') +
              ctrl.getDayName(dayOfTheWeek);
            break;
          case 5:
            output =
              (numberOfWeek === 5 ? 'the last ' : 'the fifth ') + ctrl.getDayName(dayOfTheWeek);
            break;
          case 6:
            output = `the last ${ctrl.getDayName(dayOfTheWeek)}`;
            break;
          default:
            break;
        }
        return output;
      };

      // Search for Job Types
      ctrl.searchJobTypes = (query) =>
        query ? ctrl.jobTypes.filter(ctrl.createFilterFor(query)) : [];

      ctrl.createFilterFor = (query) =>
        function filterFn(job) {
          return job.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
        };

      ctrl.searchTermChange = (searchTerm) => {
        ctrl.job.name = searchTerm;
      };

      ctrl.selectedItemChange = (selectedItem) => {
        if (selectedItem) {
          ctrl.job.name = selectedItem.name;
          ctrl.job.description = selectedItem.description;
          ctrl.job.items = selectedItem.items;
          ctrl.job.idLabels = selectedItem.idLabels ? selectedItem.idLabels : [];
          ctrl.job.jobTemplate = selectedItem?.id
            ? {
                id: selectedItem.id
              }
            : undefined;
        }
      };

      // Add/Delete Sub-Tasks
      ctrl.addSubItem = () => {
        ctrl.job.items.push(JobItem.blank());
      };

      ctrl.deleteSubItem = (index) => {
        ctrl.job.items.splice(index, 1);
      };

      ctrl.isJobValid = () =>
        (ctrl.job.name !== '' && ctrl.job.idAssignedTo && ctrl.job.absoluteDueDate !== 0) ||
        ctrl.startSaveProcess;

      ctrl.confirm = () => {
        if (ctrl.job.name && ctrl.job.idAssignedTo) {
          if (ctrl.showAdditionalOptions) {
            if (ctrl.job.idContact && !ctrl.job.idWorkflow && !ctrl.job.idTicket) {
              ctrl.save({ job: ctrl.job });
            } else if (!ctrl.job.idContact && ctrl.job.idWorkflow && ctrl.job.idTicket) {
              ctrl.save({ job: ctrl.job });
            } else {
              uiService.toast({
                text: {
                  p1: 'Task',
                  p2:
                    ctrl.job.idContact && !ctrl.job.idWorkflow && !ctrl.job.idTicket
                      ? 'Contact'
                      : 'Workflow and Deal',
                  p3:
                    !ctrl.job.idContact && ctrl.job.idWorkflow && ctrl.job.idTicket
                      ? 'is required'
                      : 'are required'
                },
                warn: true
              });
            }
          } else {
            ctrl.save({ job: ctrl.job });
          }
        } else {
          uiService.toast({
            text: {
              p1: 'Task',
              p2: 'name and assigned to',
              p3: 'are required'
            },
            warn: true
          });
        }
      };

      ctrl.cancel = () => {
        ctrl.startSaveProcess = true;
        ctrl.onCancelled();
        $timeout(() => {
          ctrl.initialize();
        });
      };

      ctrl.save = (res) => {
        const result = res;
        result.job.jobProgress = result.job.isCompleted
          ? JobProgress.of('done')
          : JobProgress.of('to_do');
        jobService.createJob(result.job).then((data) => {
          if (data.status) {
            result.job.id = data.id;
            result.job.isNew = true;
            ctrl.cancel();
            ctrl.onFinished({ job: result.job });
            uiService.toast({
              text: {
                p1: 'Task',
                p2: result.job.getName(),
                p3: 'has been added'
              }
            });
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
